module.exports = __webpack_public_path__ + "img/statistic-up-blue-grey.43e9d5be.svg";